import { render } from "./HeroiconsOutlineShare.vue?vue&type=template&id=fc309cc4"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineShare.vue"]])

export default __exports__